// extracted by mini-css-extract-plugin
export default {"note":"ResolveSubmissionModal_note__g1o+L"};